<template>
  <div>
    Hi... I'm a crappy secret database component
    <br />
    <button type="button" class="btn btn-secondary" @click="realtimeCall">
      Call Realtime Database
    </button>
    <dir>{{ dbDataInVue }}</dir>
    <br />
    <button class="btn btn-success" @click="firestoreCall">
      Call Firestore (1 Doc)
    </button>
    <div>{{ firestoreInVue }}</div>
    <br />
    <span
      ><button class="btn btn-success" @click="fireMultiple">
        Call Firestore (Multiple)</button
      ><span>----</span>
      <button class="btn btn-success" @click="fireAll">
        Call Firestore (All Values)
      </button><span>----</span>
      <button class="btn btn-danger" @click="clear">
        Clear
      </button>
    </span>

    <div>{{ firestoreArray }}</div>
    <br />

    <div>
      First Name
      <input type="text" v-model="vueFirst" /><br />
      Last Name
      <input type="text" v-model="vueLast" />
    </div>
    <button class="btn btn-primary" @click="addUser">Add User Record</button>

    <button class="btn btn-warning" @click="addHawk">Add Hawk</button>
    <div>Added: {{ numHAWKs }} Hawks</div>
  </div>
</template>

<script>
import firebaseApp, { fireDB } from "../firebaseConfigAndInit.js";

export default {
  data() {
    return {
      vueFirst: "",
      vueLast: "",
      numHAWKs: 0,
      currentUser: {
        name: ""
      },
      dbDataInVue: { basically: "blank" },
      firestoreInVue: {},
      firestoreArray: []
    };
  },
  created() {},
  methods: {
    clear() {
      this.firestoreArray = [];
    },
    async fireAll() {
      console.log("fire All clicked");
      let snap = await fireDB
        .collection("users")
        .orderBy("TPID")
        .get();
      snap.forEach(doc => {
        console.log(doc.id, ">>>", doc.data());
        this.firestoreArray.push(doc.data());
      });
    },
    async fireMultiple() {
      console.log("fireMultiple clicked");
      //Get MULTIPLE documents
      //Promise<firebase.firestore.QuerySnapshot<firebase.firestore.DocumentData>>
      let snap = await fireDB
        .collection("users")
        .where("Vibe", "==", "Climber")
        .get();
      snap.forEach(item => {
        console.log(item.data());
        this.firestoreArray.push(item.data());
      });
    },
    async firestoreCall() {
      //return ONE document
      //See https://youtu.be/rUz4oz7dTno?t=142
      //See https://firebase.google.com/docs/firestore/query-data/get-data
      let raw = fireDB.collection("users").doc("P9Qs3ABbLNzQLJXIKUEZ");
      const result = await raw.get();
      console.log(result.data());
      this.firestoreInVue = result.data();
    },
    async realtimeCall() {
      try {
        firebaseApp
          .database()
          .ref("users")
          .on("value", snap => {
            this.dbDataInVue = snap.child("Dylan/Bike").val();
          });
      } catch (error) {
        alert("an error occured, see more info in console.log");
        console.log(error);
      }
    },
    addHawk() {
      let hawk = { latitude: 32.22, longitude: -110.92 };
      console.log(hawk);
      this.numHAWKs++;
    },
    addUser() {
      //To add a database record -- https://firebase.google.com/docs/firestore/manage-data/add-data
      fireDB
        .collection("users")
        .doc()
        .set({
          name: {
            first: this.vueFirst,
            last: this.vueLast
          },
          Vibe: "Mom",
          Bike: "Easy Rider"
        })
        .then(() => {
          this.vueFirst = "";
          this.vueLast = "";
          console.log("Mom should have been added.");
        })
        .catch(() => {
          console.error;
        }); // having .doc() be blank and not .doc("something"), will set the document id as an auto-ID
    }
  }
};
</script>

<style lang="scss" scoped>
div {
  color: white;
  border: solid 1px black;
  margin: 10px;
  padding: 10px;
  background-color: rgb(146, 146, 146);
}
</style>
